import React from "react";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import { useTabs } from "./TabsContext";

export default function CandidateProfileTabs() {
  const { value, setValue } = useTabs();

  const tabs = ["Details", "Applications", "Interviews", "Notifications"];

  return (
    <Box>
      <Typography
        variant="h6"
        sx={{ fontWeight: 500, mb: 1, color: "#333", fontSize: "1rem", padding: 0 }}
      >
        Candidate Profile
      </Typography>

      <Tabs
        value={value}
        onChange={(e, newValue) => setValue(newValue)}
        TabIndicatorProps={{
          style: {
            backgroundColor: "#b388ff",
            height: "3px",
            borderRadius: 2,
          },
        }}
        sx={{
          "& .MuiTab-root": {
            textTransform: "none",
            fontWeight: 500,
            color: "#777",
            fontSize: "14px",
            mr: 3,
          },
          "& .Mui-selected": { color: "#9c27b0" },
        }}
      >
        {tabs.map((label, i) => (
          <Tab key={i} label={label} />
        ))}
      </Tabs>
    </Box>
  );
}
